import { EventEmptyState } from "./EventEmptyState";

export const EventNotOnline = () => {
  return <EventEmptyState title="Cet événement n'est pas encore en ligne" />;
};

export default EventNotOnline;
